var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSignUpApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.3726 0 0 5.3726 0 12s5.3726 12 12 12 12-5.3726 12-12S18.6274 0 12 0zm1.8286 6.0808c.4582-.5915.8055-1.4274.6799-2.2807-.7489.052-1.6242.5311-2.1349 1.1556-.4656.5658-.8482 1.4076-.6988 2.2246.8187.0256 1.6636-.4651 2.1538-1.0995zm4.0464 8.0267c-2.3829-.9062-2.7647-4.2938-.4064-5.594-.7193-.9021-1.7301-1.425-2.6842-1.425-.6875 0-1.1586.1794-1.5868.3425-.3569.136-.684.2605-1.0818.2605-.43 0-.8107-.1365-1.2094-.2794-.4381-.1571-.8978-.322-1.4683-.322-1.0707 0-2.2104.6543-2.933 1.7728-1.0157 1.5752-.8424 4.5366.8047 7.0594.5887.9029 1.3754 1.9173 2.4042 1.9264.4269.0042.711-.1232 1.0184-.2611.3519-.1578.7343-.3293 1.3965-.3329.6661-.004 1.0425.1697 1.3897.3298.2995.1382.5773.2663 1.0005.2617 1.0297-.0083 1.8598-1.1325 2.4486-2.0354.422-.6468.5797-.9731.9073-1.7033z",
    fill: "#ED0D6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignUpApple);
export default __webpack_public_path__ + "static/media/Icon-Sign-Up-Apple.f09d185c9e128db936cb23b278d3be13.svg";
export { ForwardRef as ReactComponent };